window.mx = window.mx || {};

window.mx.MxProductGrid = class extends window.mx.MxSection {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('.card-cta[data-action="click-on-stock-alert-button"]').forEach((button) => {
      const card = button.closest('.mx-product-card');
      this.eventManager.addListener(button, 'click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.onBISButtonClick(card);
      });
    });
  }

  onBISButtonClick(card) {
    const scriptEl = card.querySelector('.bis-product-data');
    if (!scriptEl) return;

    const variantDataJson = JSON.parse(scriptEl.textContent);

    if (!BIS) {
      console.error('Back In Stock not loaded');
      return false;
    }

    BIS.Config.product = variantDataJson;

    BIS.popup = BIS.createPopover();
    BIS.popup?.toggle();
    BIS.popup?.form?.frame?.contentDocument?.querySelector('.action-close')?.style?.setProperty('display', 'block');
    BIS.popup?.form?.frame?.contentDocument?.querySelector('#variants')?.querySelectorAll('option')?.forEach((option) => {
      if (option.textContent.startsWith('Réservation')) {
        option.remove();
      }
    });
  }
};
if (!window.customElements.get('mx-product-grid'))
  window.customElements.define('mx-product-grid', window.mx.MxProductGrid);
